import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../../hooks/auth'
import { useEffect } from 'react'
import { redirectUser } from '../../utils/redirectUser'
import { PAINEL_URL, SSO_URL } from '../../config'
import amplitude from '../../utils/amplitude'
import Loader from '../../components/Loader'
import useBdAppEventBus from '../../hooks/bdapp/useBdAppEventBus'

export default function Auth() {
  const { publish } = useBdAppEventBus()
  const { status, accessToken, login } = useAuth()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const token = searchParams.get('token') ?? ''
  const sso = searchParams.get('sso') ?? ''
  const url = searchParams.get('url') ?? ''
  const username = searchParams.get('username') ?? ''

  useEffect(() => {
    if (token) {
      login({ token, sso })
    } else if (username) {
      const url = new URL(PAINEL_URL)
      url.searchParams.set('username', username)
      redirectUser(url.toString())
    } else {
      const url = new URL(SSO_URL)
      url.searchParams.set('redirect_uri', window.location.origin + '/auth')
      redirectUser(url.toString())
    }
  }, [token, login, sso, username])

  useEffect(() => {
    if (status === 'logged') {
      publish('logged', { jwt: accessToken })
    }

    if (status === 'logged' && url) {
      navigate(url)
      amplitude.track('user-logged-in-dashboard', { url })
    } else if (status === 'logged') {
      navigate('/')
      amplitude.track('user-logged-in-dashboard', { url: '/' })
    } else if (status === 'not-logged') {
      const url = new URL(SSO_URL)
      url.searchParams.set('redirect_uri', window.location.origin + '/auth')
      redirectUser(url.toString())
    }
  }, [status, url, navigate, publish, accessToken])

  return (
    <div
      data-testid="auth-component"
      data-testid-status={status}
      style={{
        width: '100%',
        height: '100%',
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Loader />
    </div>
  )
}
